import { ChangeDetectionStrategy, Component, inject } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { Router } from "@angular/router";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { IconComponent } from "@components/icon/icon.component";
import { InputComponent } from "@components/input/input.component";
import { LabelComponent } from "@components/label/label.component";
import { ListColumnDirective } from "@components/list/list-column.directive";
import { ListComponent } from "@components/list/list.component";
import { PageComponent } from "@components/page/page.component";
import { SelectorComponent } from "@components/selector/selector.component";
import { orderBy } from "lodash";
import { RaskModalService } from "~app/common/components/modal/rask-modal.service";
import { ExternArbetsorderDetailsComponent } from "../extern-arbetsorder-details.component";

@Component({
    selector: "rask-extern-arbetsorder-details-viol2",
    templateUrl: "./extern-arbetsorder-details-viol2.component.html",
    styleUrls: ["../extern-arbetsorder-details.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        PageComponent,
        InputComponent,
        FormsModule,
        SelectorComponent,
        LabelComponent,
        IconComponent,
        ListComponent,
        ListColumnDirective,
        CheckboxComponent
    ]
})
export class ExternArbetsorderDetailsViol2Component extends ExternArbetsorderDetailsComponent {
    readonly router = inject(Router);
    readonly raskModalService = inject(RaskModalService);

    getListData() {
        return orderBy(this.externArbetsorderDetails.destineringsrader, (obj) => parseInt(obj.radnummer, 10), "asc");
    }
}
